import facebook from '../../assets/facebook.svg'
import githubIcon from '../../assets/github.svg'
import instagramIcon from '../../assets/instagram.svg'
import linkedin from '../../assets/linkedin.svg'
import reactIcon from '../../assets/react-icon.svg'
import whatsapp from '../../assets/whatsapp.svg'
import { Container } from './styles'

export function Footer() {
  return (
    <Container className="footer">
      <a href="https://senthvyra.com" className="logo">
        <span>senthvyra.com</span>
      </a>
      <div>
        <p>
          Senth Vyra &copy; {new Date().getFullYear()}
          {/* <span>❤️</span> <img src={reactIcon} alt="React" />*/}
        </p>
      </div>
      <div className="social-media">
        <a
        href="https://www.linkedin.com/in/senthvyra/"
        target="_blank"
          rel="noreferrer"
        >
          <img src={linkedin} alt="Linkedin" />
        </a>
        <a
          href="https://github.com/senthvyra/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={githubIcon} alt="GitHub" />
        </a>
        <a
          href="https://api.whatsapp.com/send/?phone=%2B94701111055&text=Hello+Senth%2C+I+found+your+contact+on+your+website+and+I+would+like+to+talk+to+you+about+your+services."
          target="_blank"
          rel="noreferrer"
        >
          <img src={whatsapp} alt="Whatsapp" />
        </a>
        <a
          href="https://www.facebook.com/senthvyra"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebook} alt="facebook" />
        </a>
        <a
          href="https://www.instagram.com/senthvyra/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagramIcon} alt="Instagram" />
        </a>
      </div>
    </Container>
  )
}
